import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BackendPagination } from "../models/pagination.model";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { TaskQueryOptions } from "../models/endpoints/tasks.model";

/** See `useTasks` for why `options` exists. */
export const useTasksCount = (pagination: BackendPagination, options?: TaskQueryOptions) => {
	const queryClient = useQueryClient();
	const queryKey = ["participants-tasks-count", pagination];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getTasksCount({
				config: {
					params: {
						search: pagination.search,
						filters: pagination.filters,
					},
				},
			});
			return response;
		},
		...options,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
